import Header from './components/Header';
import Hero from './components/Hero';
import TopicsSection from './components/TopicsSection';
import AppSection from './components/AppSection';
import IndexSection from './components/IndexSection';
import CommentsSection from './components/CommentsSection';
import AboutSection from './components/AboutSection';
import ContactSection from './components/ContactSection';
import CarouselSection from './components/CarouselSection';
import MediaSection from './components/MediaSection';
import FeaturesSection from './components/FeaturesSection';
import RankingSection from './components/RankingSection';
import FaqSection from './components/FaqSection';
import UpdatesSection from './components/UpdatesSection';
import CardsSection from './components/CardsSection';
import Footer from './components/Footer';

export default function Home() {
  return (
    <>
      <Header />
      <main>
        <Hero />
        <TopicsSection />
        <AppSection />
        <IndexSection />
        <CommentsSection />
        <AboutSection />
        <ContactSection />
        <CarouselSection />
        <MediaSection />
        <FeaturesSection />
        <RankingSection />
        <FaqSection />
        <UpdatesSection />
        <CardsSection />
      </main>
      <Footer />
    </>
  );
}